// extracted by mini-css-extract-plugin
export default {"section":"Program_section__5h-yN","container":"Program_container__mbdw1","content":"Program_content__oe2K-","title":"Program_title__-TZKF"};